export enum MenuColorScheme {
  RED = 0,
  ORANGE = 1,
}
